declare namespace $ {

	export class $shm_hitalama_keepsize extends $mol_plugin {
		transform( ): string
		translate( ): string
		transformOrigin( ): string
		zoom( ): number
		min_zoom( ): number
		anchor_hor( ): string
		anchor_vert( ): string
		style( ): ({ 
			'transform': ReturnType< $shm_hitalama_keepsize['transform'] >,
			'translate': ReturnType< $shm_hitalama_keepsize['translate'] >,
			'transformOrigin': ReturnType< $shm_hitalama_keepsize['transformOrigin'] >,
		})  & ReturnType< $mol_plugin['style'] >
	}
	
}

//# sourceMappingURL=keepsize.view.tree.d.ts.map